//
// WARNING: this file was auto-generated by @phensley/cldr-compiler. DO NOT EDIT.
//
export var pluralRanges = {
    af: 5,
    ak: { 66: 5, 96: 5, 1026: 1, 1056: 5 },
    am: { 66: 1, 96: 5, 1056: 5 },
    an: 5,
    ar: {
        34: 0,
        36: 0,
        40: 3,
        48: 4,
        64: 5,
        68: 5,
        72: 3,
        80: 4,
        96: 5,
        136: 3,
        144: 4,
        160: 5,
        264: 3,
        272: 4,
        288: 5,
        520: 3,
        528: 4,
        544: 5,
        1026: 5,
        1028: 5,
        1032: 3,
        1040: 4,
        1056: 5
    },
    as: { 66: 1, 96: 5, 1056: 5 },
    az: { 96: 5, 1026: 1, 1056: 5 },
    be: {
        66: 1,
        72: 3,
        80: 4,
        96: 5,
        258: 1,
        264: 3,
        272: 4,
        288: 5,
        514: 1,
        520: 3,
        528: 4,
        544: 5,
        1026: 1,
        1032: 3,
        1040: 4,
        1056: 5
    },
    bg: 5,
    bn: { 66: 1, 96: 5, 1056: 5 },
    bs: { 66: 1, 72: 3, 96: 5, 258: 1, 264: 3, 288: 5, 1026: 1, 1032: 3, 1056: 5 },
    ca: 5,
    cs: {
        72: 3,
        80: 4,
        96: 5,
        264: 3,
        272: 4,
        288: 5,
        514: 1,
        520: 3,
        528: 4,
        544: 5,
        1026: 1,
        1032: 3,
        1040: 4,
        1056: 5
    },
    cy: {
        34: 1,
        36: 2,
        40: 3,
        48: 4,
        64: 5,
        68: 2,
        72: 3,
        80: 4,
        96: 5,
        136: 3,
        144: 4,
        160: 5,
        272: 4,
        288: 5,
        544: 5,
        1026: 1,
        1028: 2,
        1032: 3,
        1040: 4,
        1056: 5
    },
    da: { 66: 1, 96: 5, 1026: 1, 1056: 5 },
    de: { 96: 5, 1026: 1, 1056: 5 },
    el: { 96: 5, 1026: 1, 1056: 5 },
    en: 5,
    es: 5,
    et: 5,
    eu: 5,
    fa: { 66: 5, 96: 5, 1026: 1, 1056: 5 },
    fi: 5,
    fil: { 66: 1, 96: 5, 1026: 1, 1056: 5 },
    fr: { 66: 1, 96: 5, 1056: 5 },
    ga: {
        68: 2,
        72: 3,
        80: 4,
        96: 5,
        136: 3,
        144: 4,
        160: 5,
        264: 3,
        272: 4,
        288: 5,
        528: 4,
        544: 5,
        1026: 1,
        1028: 2,
        1032: 3,
        1040: 4,
        1056: 5
    },
    gl: { 96: 5, 1026: 1, 1056: 5 },
    gsw: { 96: 5, 1026: 1, 1056: 5 },
    gu: { 66: 1, 96: 5, 1056: 5 },
    he: { 68: 5, 80: 4, 96: 5, 144: 5, 160: 5, 528: 4, 544: 4, 1026: 5, 1028: 5, 1040: 4, 1056: 5 },
    hi: { 66: 1, 96: 5, 1056: 5 },
    hr: { 66: 1, 72: 3, 96: 5, 258: 1, 264: 3, 288: 5, 1026: 1, 1032: 3, 1056: 5 },
    hu: { 96: 5, 1026: 1, 1056: 5 },
    hy: { 66: 1, 96: 5, 1056: 5 },
    ia: 5,
    id: 5,
    io: 5,
    is: { 66: 1, 96: 5, 1026: 1, 1056: 5 },
    it: { 96: 5, 1026: 1, 1056: 5 },
    ja: 5,
    ka: { 96: 1, 1026: 5, 1056: 5 },
    kk: { 96: 5, 1026: 1, 1056: 5 },
    km: 5,
    kn: { 66: 1, 96: 5, 1056: 5 },
    ko: 5,
    ky: { 96: 5, 1026: 1, 1056: 5 },
    lo: 5,
    lt: {
        66: 1,
        72: 3,
        80: 4,
        96: 5,
        258: 1,
        264: 3,
        272: 4,
        288: 5,
        514: 1,
        520: 3,
        528: 4,
        544: 5,
        1026: 1,
        1032: 3,
        1040: 4,
        1056: 5
    },
    lv: { 33: 5, 34: 1, 64: 5, 65: 5, 66: 1, 96: 5, 1025: 5, 1026: 1, 1056: 5 },
    mk: 5,
    ml: { 96: 5, 1026: 1, 1056: 5 },
    mn: { 96: 5, 1026: 1, 1056: 5 },
    mr: { 66: 1, 96: 5, 1056: 5 },
    ms: 5,
    my: 5,
    nb: 5,
    ne: { 96: 5, 1026: 1, 1056: 5 },
    nl: { 96: 5, 1026: 1, 1056: 5 },
    or: { 66: 5, 96: 5, 1026: 1, 1056: 5 },
    pa: { 66: 1, 96: 5, 1026: 1, 1056: 5 },
    pcm: 5,
    pl: {
        72: 3,
        80: 4,
        96: 5,
        264: 3,
        272: 4,
        288: 5,
        514: 1,
        520: 3,
        528: 4,
        544: 5,
        1026: 1,
        1032: 3,
        1040: 4,
        1056: 5
    },
    ps: { 66: 1, 96: 5, 1056: 5 },
    pt: { 66: 1, 96: 5, 1056: 5 },
    ro: { 72: 3, 96: 5, 258: 3, 264: 3, 288: 5, 1032: 3, 1056: 5 },
    ru: {
        66: 1,
        72: 3,
        80: 4,
        96: 5,
        258: 1,
        264: 3,
        272: 4,
        288: 5,
        514: 1,
        520: 3,
        528: 4,
        544: 5,
        1026: 1,
        1032: 3,
        1040: 4,
        1056: 5
    },
    sc: { 96: 5, 1026: 1, 1056: 5 },
    scn: { 96: 5, 1026: 1, 1056: 5 },
    sd: { 66: 5, 96: 5, 1026: 1, 1056: 5 },
    si: { 66: 1, 96: 5, 1026: 5, 1056: 5 },
    sk: {
        72: 3,
        80: 4,
        96: 5,
        264: 3,
        272: 4,
        288: 5,
        514: 1,
        520: 3,
        528: 4,
        544: 5,
        1026: 1,
        1032: 3,
        1040: 4,
        1056: 5
    },
    sl: {
        66: 3,
        68: 2,
        72: 3,
        96: 5,
        130: 3,
        132: 2,
        136: 3,
        160: 5,
        258: 3,
        260: 2,
        264: 3,
        288: 5,
        1026: 3,
        1028: 2,
        1032: 3,
        1056: 5
    },
    sq: { 96: 5, 1026: 1, 1056: 5 },
    sr: { 66: 1, 72: 3, 96: 5, 258: 1, 264: 3, 288: 5, 1026: 1, 1032: 3, 1056: 5 },
    sv: 5,
    sw: { 96: 5, 1026: 1, 1056: 5 },
    ta: { 96: 5, 1026: 1, 1056: 5 },
    te: { 96: 5, 1026: 1, 1056: 5 },
    th: 5,
    tk: { 96: 5, 1026: 1, 1056: 5 },
    tr: { 96: 5, 1026: 1, 1056: 5 },
    ug: { 96: 5, 1026: 1, 1056: 5 },
    uk: {
        66: 1,
        72: 3,
        80: 4,
        96: 5,
        258: 1,
        264: 3,
        272: 4,
        288: 5,
        514: 1,
        520: 3,
        528: 4,
        544: 5,
        1026: 1,
        1032: 3,
        1040: 4,
        1056: 5
    },
    ur: 5,
    uz: { 96: 5, 1026: 1, 1056: 5 },
    vi: 5,
    yue: 5,
    zh: 5,
    zu: { 66: 1, 96: 5, 1056: 5 }
};
//# sourceMappingURL=autogen.ranges.js.map